/* Reopen Shopify's native privacy dialog from the existing footer link.
 * No consent is set or inferred here; choices stay with the native dialog.
 */
(() => {
  let loading;
  function loadBanner() {
    if (typeof privacyBanner !== 'undefined' && privacyBanner.showPreferences) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch((error) => { loading = null; throw error; });
    return loading;
  }
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('a[href="#shopifyReshowConsentBanner"]')
      : null;
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    loadBanner().then(() => privacyBanner.showPreferences()).catch((error) => {
      console.error('Shopify privacy preferences could not be opened:', error?.message || 'Banner script unavailable');
    });
  }, true);
})();
